import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'

import { RequestErrorType } from '@core/utils/api-axios-instance'
import { IBriefingSession } from '@core/entities/briefing'
import { briefingKeys, RequestTypes } from '@core/react-query/features/briefing'
import { optimisticallyHandleBriefingSession } from '@core/react-query/features/briefing/helpers'

export const useDiscardBriefingSession = (
  options: UseMutationOptions<
    IBriefingSession,
    RequestErrorType,
    RequestTypes['discardBriefingSession']
  > = {},
) => {
  const queryClient = useQueryClient()

  return useMutation({
    ...options,
    ...briefingKeys.discardBriefingSession,
    onSuccess: (...args) => {
      const [data] = args

      optimisticallyHandleBriefingSession(queryClient, data)
      options.onSuccess?.(...args)
    },
  })
}
